import React from 'react';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { sendEvents } from '../../../../redux/actions/Home';
import CloseIcon from '../../../public/images/icon-close.png';
import SelectorIcon from '../../../public/images/selectorIcon.png';
import './selectorpopup.scss';

export const SelectorPopup = ({ closepopup, handleClose }) => (
  <div className="selector-pop-up" onClick={closepopup}>
    <img
        src={CloseIcon}
        alt="close-icon"
        align="right"
        style={{ width: '12px' }}
        onClick={() => {
          handleClose();
        }} />
    <div className="selector-icon-div">
      <img className="selector-icon" src={SelectorIcon} alt="selectorIcon" />
    </div>
    <div className="card-title">
      <p>Are you sure you want to change your fundraiser allocation?</p>
    </div>
    <div className="selector-btn-div">
      <Link to="/allocatefunds">
        <Button
            className="proceed-btn text-bold"
            onClick={() => {
              sendEvents('proceed_change_cta', 'sip_returning', 'allocate_fundraiser', 'impact', '', true);
              // handleRedirection(`${curLoc[0]}allocatefunds`);
            }}>
          PROCEED
        </Button>
      </Link>
      <Button
          className="cancel-btn text-bold"
          onClick={() => {
            handleClose();
          }}>
        CANCEL
      </Button>
    </div>
  </div>
);

export default SelectorPopup;
